import { alpha, Stack, styled, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import MyAvatar from "src/components/MyAvatar";
import useLocales from "src/hooks/useLocales";
import { defaultUser, User } from "src/types/user";

import Context, { ContextType } from "../context";

// ----------------------------------------------------------------------

const StyledRoot = styled("div")(({ theme }) => ({
	display: "inline-flex",
	cursor: "pointer",
	padding: theme.spacing(3, 2.5),
	overflow: "hidden",
	alignItems: "center",
	backgroundColor: theme.palette.background.paper,
	":hover": {
		backgroundColor: alpha(theme.palette.grey[500], 0.12)
	}
}));

type Props = {
	onOpen: (event: React.MouseEvent<HTMLElement>) => void;
};

export default function AccountItem({ onOpen }: Props) {
	const { isCollapse }: ContextType = useContext<ContextType>(Context);

	const { data: user } = useQuery<User>({ queryKey: ["user"], initialData: defaultUser });

	const { translate } = useLocales();

	return (
		<StyledRoot onClick={onOpen} sx={{ justifyContent: isCollapse ? "center" : "space-between" }}>
			<MyAvatar user={{ name: user?.organization?.name, imageUrl: "" }} />
			{!isCollapse && (
				<>
					<Stack justifyContent='center' sx={{ ml: { xs: 1, sm: 1.5 } }}>
						<Typography
							color={"text.secondary"}
							fontSize={12}
							maxWidth={110}
							noWrap
							variant='subtitle2'
						>
							{`${translate("account_popover.hello")} ${user?.organization?.name}`}
						</Typography>
						<Typography color='text.primary' noWrap sx={{ lineHeight: 1 }} variant='subtitle2'>
							{translate("account_popover.org")}
						</Typography>
					</Stack>
					<Iconify icon='iconamoon:menu-kebab-vertical-bold' ml='auto' />
				</>
			)}
		</StyledRoot>
	);
}
